// extracted by mini-css-extract-plugin
module.exports = {"varSpBase":"1rem","loadingContainer":"loadingContainer--f14b7","spinner":"spinner--791de"};